import * as productActionTypes from "ActionTypes/productActionTypes";
import cloneDeep from "lodash/cloneDeep";
//import appActions from "Actions/appActions";
import getProducts from "Services/http/getProducts";
import Products from "Services/products";

//MAY NEED AN initActiveParent/initActiveChild methods....

const productActions = (() => {
  const actions = {
    initProductData: () => {
      return dispatch => {
        dispatch(actions.getProductData());
      };
    },
    getProductData: () => {
      return (dispatch, getState) => {
        const state = getState();
        //show loading icon
        //let isLoading = true;
        //dispatch(appActions.setIsLoading(isLoading));

        let { country, language } = state.locale;
        let { catalogType, catalogName } = state.app;

        const payload = {
          country: country,
          language: language,
          catalogType: catalogType,
          catalogName: catalogName
        };

        getProducts
          .init(payload)
          .then(res => {
            let catalog = res.data;
            dispatch(actions.setCatalog(catalog));
            dispatch(actions.getQuotesData());
            /*let itemCodes = Products.getItemCodes(clonedCatalog);

            const quoteload = {
              country: country,
              customerType: customerType,
              itemCodes: itemCodes.join("|")
            };

            getProducts.productQuotes(quoteload).then(quotes => {
              let pricing = quotes.data.items;
              let products = Products.addPricing(clonedCatalog, pricing);
              //dispatch(actions.setPricing(pricing));
              //dispatch(actions.setProducts(products));
              dispatch(actions.setCatalog(products));
            });*/


          })
          .catch(err => {
          })
          .finally(() => {
            //let isLoading = false;
            //dispatch(appActions.setIsLoading(isLoading));
          });
      };
    },
    getQuotesData: (custType="") => {
      return (dispatch, getState) => {
      const state = getState();
      //show loading icon
      //let isLoading = true;
      //dispatch(appActions.setIsLoading(isLoading));

      let { country } = state.locale;
      let customerType  = custType!==""?custType:state.app.customerType;
      let { catalog } = state.products;
      let clonedCatalog = cloneDeep(catalog);
      let itemCodes = Products.getItemCodes(catalog);
      const quoteload = {
        country: country,
        customerType: customerType,
        itemCodes: itemCodes.join("|")
      };

      getProducts.productQuotes(quoteload).then(quotes => {
            let pricing = quotes.data.items;
            let catalogWithPrice = Products.addPricing(clonedCatalog, pricing);

            //dispatch(actions.setPricing(pricing));
            //dispatch(actions.setProducts(products));

            dispatch(actions.setPricing(catalogWithPrice));
        })
        .catch(err => {
        })
        .finally(() => {
          //let isLoading = false;
          //dispatch(appActions.setIsLoading(isLoading));
        });
      };
    },
    setCatalog: catalog => {
      return {
        type: productActionTypes.SET_CATALOG,
        catalog
      };
    },
    setPricing: catalogWithPrice => {
      return {
        type: productActionTypes.SET_PRICING,
        catalogWithPrice
      };
    },
    setProducts: products => {
      return {
        type: productActionTypes.SET_PRODUCTS,
        products
      };
    },
    changeIOShipOption: option => {
      return {
        type: productActionTypes.CHANGE_IO_SHIP_OPTIONS,
        option
      };
    },
    clearSelectedPack: () => {
      return {
        type: productActionTypes.CLEAR_SELECTED_PACK
      };
    },
    clearSelectedPackItem: () => {
      return {
        type: productActionTypes.CLEAR_SELECTED_PACK_ITEM
      };
    },
    setSelectedPack: packs => {
      return {
        type: productActionTypes.SET_SELECTED_PACK,
        packs
      };
    },
    selectedPackItem: selectedPackItem => {
      return {
        type: productActionTypes.SELECTED_PACK,
        selectedPackItem
      };
    }
  };

  return actions;
})();

export default productActions;



// WEBPACK FOOTER //
// ./src/store/actions/productActions.js